import React from "react";
import PageHeader from "./../PageHeader";
import { Modal, Row, Col, Button, Typography } from "antd";
import { MoreOutlined } from "@ant-design/icons";
import "./account.css";
import { useDispatch, useSelector } from "react-redux";
import { corporateBudget } from "../../actions/cards/cards";
import { amountFormat } from "../../utils";
import { companyProfile, companySetting } from "../../actions/companySettings";
import BaseCurrency from "../Common/BaseCurrency";
import { useHistory } from "react-router-dom";

const { Title, Text } = Typography;

const Account = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const companyProfileResponse = useSelector(
    (state) => state.companySetting.companyProfile || {}
  );
  const companySettingResponse = useSelector(
    (state) => state.companySetting.companySetting || {}
  );
  const { data: { response: { company = {} } = {} } = {} } =
    companyProfileResponse;

  const {
    data: { response: { company_setting: { company_id = "" } = {} } = {} } = {},
  } = companySettingResponse;

  const [isModalVisible, setIsModalVisible] = React.useState(false);
  const corporate_budget = useSelector(
    (state) => state.cards.corporate_budget?.data?.response
  );

  React.useEffect(() => {
    dispatch(corporateBudget());
    dispatch(companySetting({ files: false }));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    if (company_id) {
      dispatch(companyProfile({ id: company_id, files: false }));
    }
    // eslint-disable-next-line
  }, [company_id]);

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const renderViewAccount = () => {
    return (
      <>
        <Text>Step 1</Text>
        <div className="viewAccount">
          <Text className="notBold">
            Add Paycraft as a new beneficiary in your current account using the
            account information given below.
          </Text>
        </div>
        <br />
        <Text>Step 2</Text>
        <div className="viewAccount">
          <Row>
            <Col span={8}>
              <p>Account Name</p>
              <p>Account Number</p>
              <p>IFSC Code</p>
              <p>Account Type</p>
              <p>Address</p>
              <br />
              <br />
              <p>Bank Name</p>
              <p>Branch</p>
            </Col>
            <Col span={12}>
              <span>{company?.account_name}</span>
              <br />
              <span>{company?.account_number}</span>
              <br />
              <span>{company?.account_ifsc}</span>
              <br />
              <span>{company?.account_type}</span>
              <br />
              <span>{company?.bank_address}</span>
              <br />
              <span>{company?.bank_name}</span>
            </Col>
          </Row>
        </div>
        <br />
        <Text>Step 3</Text>
        <div className="viewAccount">
          <Text className="notBold">
            Transfer funds from your current account to Paycraft account via
            NEFT/RTGS /IMPS information given below.
          </Text>
        </div>
      </>
    );
  };

  return (
    <>
      <Modal
        title={
          <Title level={4}>
            View Account Details &nbsp;
            <span className="text-small">Load Money in to Funding Account</span>
          </Title>
        }
        visible={isModalVisible}
        onCancel={handleCancel}
        footer={[]}
        className="right-alinged-modal"
      >
        {renderViewAccount()}
      </Modal>
      <div className="heading-div">
        <PageHeader
          title={`Account`}
          navigation={{
            Home: "/dashboard/",
            Account: "/account/",
          }}
        />
      </div>
      <div className="contentWrapper">
        <Row className="accountHead">
          <Col span={12}>
            <Title level={5}>{company?.name}</Title>
          </Col>
          <Col span={4}>
            <div className="account-budget ">
              <Title className="balanceTitle" level={5}>
                Balance
              </Title>
              <Text className="balanceText">
                <BaseCurrency />{" "}
                {corporate_budget?.currentLimit &&
                  amountFormat(corporate_budget?.currentLimit)}{" "}
              </Text>
            </div>
          </Col>
          <Col span={8}>
            <Button
              key="2"
              className="cancelButton"
              onClick={() => {
                history.push("/account-transaction");
              }}
            >
              Transaction History
            </Button>
            {/* <Button
              key="1"
              htmlType="submit"
              className="formButton ml1 primaryButton"
              onClick={() => setIsModalVisible(true)}
            >
              Add Funds
            </Button> */}
          </Col>
          {/* <Col span={1}>
            <MoreOutlined />
          </Col> */}
        </Row>
        <br />
        {/* <Row className="width-80 ml2 mb3">
          <Title level={5} className="accountNote">
            Note
          </Title>
          <Text>
            Load requests raised from your current accounts between 9 AM to 5:30
            PM on bank working days will be processed on the same day. All
            requests raised after the stipulated time will reflect only on the
            next bank working day as per the bank working hours.
            <br />
            <br />
          </Text>
          <Text>
            IMPS 24 * 7 / 365 days
            <br /> NEFT 08:00 AM to 06:00 PM (Daily except 2nd and 4th
            Saturdays, Sunday and RBI holidays)
            <br /> RTGS 08:00 AM to 04:00 PM (Daily except 2nd and 4th
            Saturdays, Sunday and RBI holidays)
            <br />
            <br />
          </Text>
          <Text>
            For any further queries on your account, reach out to
            care@paycraft.in.
          </Text>
        </Row> */}
      </div>
    </>
  );
};

export default Account;
